import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { useUnit } from 'effector-react';
import withReactContent from 'sweetalert2-react-content';

import { confirmationStore } from './ConfirmationStore';
import { hideConfirmation } from './ConfirmationStore';
import { ConfirmationProps } from './types';

const Component: React.FC<ConfirmationProps> = React.memo(() => {
    const confirmations = useUnit(confirmationStore);

    useEffect(() => {
        confirmations.forEach((confirmation) => {
            // eslint-disable-next-line promise/catch-or-return
            withReactContent(Swal)
                .fire({
                    title: confirmation.title || 'Are you sure?',
                    html: confirmation.html || <span>You won&#39;t be able to revert this!</span>,
                    icon: confirmation.icon || 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d41117',
                    cancelButtonColor: '#858585',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true,
                    customClass: {
                        icon: 'custom-swal-icon',
                    },
                })
                .then((result) => {
                    // eslint-disable-next-line promise/always-return
                    if (result.isConfirmed) {
                        confirmation.onConfirm && confirmation.onConfirm();
                        confirmation.id && hideConfirmation(confirmation.id);
                    } else {
                        confirmation.onCancel && confirmation.onCancel();
                        confirmation.id && hideConfirmation(confirmation.id);
                    }
                });
        });
    }, [confirmations]);

    return (
        <>
            <style>
                {`
                    .custom-swal-icon.swal2-icon.swal2-warning {
                        border-color: #E9E9E9;
                        color: #E9E9E9;
                    }
                `}
            </style>
        </>
    );
});

Component.displayName = 'ConfirmationContainer';

export const ConfirmationContainer: React.FC<ConfirmationProps> = Object.assign(Component, {});
